import http from './httpService';

export const getMetaData = (page) => {
  return http.get(`/metaData/${page}`);
};

export const saveMetaData = ({ page, item }) => {
  return http.post(`/metaData/${page}`, item);
};
